import api from '@/services/api';
import type {
    ApiItemResponse,
    ApiListResponse,
    CreateDealerContactPayload,
    DealerContact,
    UpdateDealerContactPayload,
} from '../types/dealers.types';

const dealerContactsPath = (dealerId: string): string => `/dealers/${dealerId}/contacts`;

export const fetchDealerContacts = async (dealerId: string): Promise<DealerContact[]> => {
    const response = await api.get<ApiListResponse<DealerContact>>(dealerContactsPath(dealerId));

    if (!response.data.success) {
        throw new Error('Failed to fetch dealer contacts');
    }

    return response.data.data;
};

export const createDealerContact = async (dealerId: string, payload: CreateDealerContactPayload): Promise<DealerContact> => {
    const response = await api.post<ApiItemResponse<DealerContact>>(dealerContactsPath(dealerId), payload);

    if (!response.data.success) {
        throw new Error('Failed to create dealer contact');
    }

    return response.data.data;
};

export const updateDealerContact = async (
    dealerId: string,
    contactId: string,
    payload: UpdateDealerContactPayload
): Promise<DealerContact> => {
    const response = await api.put<ApiItemResponse<DealerContact>>(`${dealerContactsPath(dealerId)}/${contactId}`, payload);

    if (!response.data.success) {
        throw new Error('Failed to update dealer contact');
    }

    return response.data.data;
};

export const deleteDealerContact = async (dealerId: string, contactId: string): Promise<void> => {
    const response = await api.delete<ApiItemResponse<null>>(`${dealerContactsPath(dealerId)}/${contactId}`);

    if (!response.data.success) {
        throw new Error('Failed to delete dealer contact');
    }
};
